
export const API_BASE_URL = 'https://mango-backend.onrender.com';
// export  const API_BASE_URL = 'http://localhost:5000';

export const SERVICE_ID = 'service_vhko9ae';

export const TEMPLATE_ID = 'template_h74rk39';

export const PUBLIC_KEY= 'sXwCQKl6w4gguUqfE';
